module.exports = __webpack_public_path__ + "img/301.e48a19c0.png";